/**
 * Initialize mobile and desktop navigation functionality
 */
const initNavigation = () => {
  const html = document.querySelector("html");
  const header = document.querySelector("header.header");

  if (!header) return;

  const siteNavigation = header.querySelector("#site-navigation");
  const primaryMenu = header.querySelector("#menu-primary");
  const menuToggle = header.querySelector("#nav-mobile");
  const subMenuToggle = header.querySelectorAll("ul > li.menu-item-has-children");
  const subSubMenuHover = header.querySelectorAll(
    "ul > li.menu-item-has-children ul > li.menu-item-has-children"
  );
  const desktopClickControllers = header.querySelectorAll("ul > li.click-controller");

  // Error check
  if (!siteNavigation || !menuToggle || !subMenuToggle || !desktopClickControllers) {
    console.warn("Required header elements are missing.");
    return;
  }

  // Menu functions
  // =============================================================================

  const openMobile = () => {
    menuToggle.setAttribute("aria-expanded", "true");
    html.classList.add("menu-opened");

    // Set focus to first focusable element
    setTimeout(() => {
      const focusableElements = siteNavigation.querySelectorAll("a[href], button");
      focusableElements[0].focus();
    }, 250);

    header.addEventListener("keydown", handleKeyboardNavigation);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeMobile();
    });

    // Set the panel menu to the current-menu-item
    if (
      siteNavigation.classList.contains("menu-panel") &&
      siteNavigation.classList.contains("current-panel")
    ) {
      const currentMenuItem = siteNavigation.querySelector(".current-menu-item");

      if (currentMenuItem) {
        const parentItem = currentMenuItem.closest(".menu-item-has-children");

        if (parentItem) {
          const subMenu = parentItem.querySelector("ul.sub-menu");
          subMenu.style.display = "block";
          showSubMenu(parentItem, subMenu);

          const parentItem2 = parentItem.parentNode.closest(".menu-item-has-children");
          // If submenu is depth 2
          if (parentItem2) {
            const subMenu2 = parentItem2.querySelector("ul.sub-menu");
            parentItem2.classList.add("submenu-visible");
            subMenu2.style.display = "block";
          }
        }
      }
    }
  };

  const closeMobile = () => {
    menuToggle.setAttribute("aria-expanded", "false");
    html.classList.remove("menu-opened");

    // Remove if you want to keep submenus open when closing the menu
    subMenuToggle.forEach((item) => {
      const subMenu = item.querySelector("ul.sub-menu");
      const subMenuHeight = subMenu.scrollHeight;
      hideSubMenu(item, subMenu, subMenuHeight);
    });

    primaryMenu.style.left = `0px`;
    header.removeEventListener("keydown", handleKeyboardNavigation);

    document.removeEventListener("keydown", (e) => {
      if (e.key === "Escape") closeMobile();
    });

    setTimeout(() => {
      menuToggle.focus();
    }, 250);
  };

  const handleKeyboardNavigation = (e) => {
    const focusableElements = header.querySelectorAll("a[href], button");
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (e.key !== "Tab" && e.keyCode !== 9) return;

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  };

  const removeDropdownOpened = (item = null) => {
    desktopClickControllers.forEach((sibling) => {
      if (sibling !== item) sibling.classList.remove("dropdown-opened");
    });
  };

  const hideSubMenu = (clickItem, menu) => {
    if (siteNavigation.classList.contains("menu-panel")) {
      if (menu.classList.contains("sub-menu-depth-1")) {
        const parentItem = clickItem
          .querySelector(".sub-menu-depth-1")
          .closest(".menu-item-has-children");
        const megaMenuItem = menu.closest(".mega-menu-container");
        primaryMenu.style.left = `0`;
        primaryMenu.classList.remove("menu-panel-opened");
        parentItem.classList.remove("submenu-visible");

        setTimeout(() => {
          menu.style.display = "none";
          if (megaMenuItem) megaMenuItem.style.display = "none";
        }, 450);
      }

      if (menu.classList.contains("sub-menu-depth-2")) {
        const parentItem = clickItem
          .querySelector(".sub-menu-depth-2")
          .closest(".menu-item-has-children");
        primaryMenu.style.left = `-${primaryMenu.clientWidth}px`;
        parentItem.classList.remove("submenu-visible");

        setTimeout(() => {
          menu.style.display = "none";
        }, 450);
      }
    }
  };

  const showSubMenu = (clickItem, menu) => {
    if (siteNavigation.classList.contains("menu-panel")) {
      primaryMenu.classList.add("menu-panel-opened");

      // Find the submenu and its depth
      const submenu = clickItem.querySelector("ul");
      if (!submenu) return;

      // Find the depth from classList (looks for sub-menu-depth-*)
      let depth = 0;
      submenu.classList.forEach((cls) => {
        const match = cls.match(/^sub-menu-depth-(\d+)$/);
        if (match) depth = parseInt(match[1], 10);
      });
      if (depth === 0) return;

      // Ensure scrollTop is 0 when opening submenu
      siteNavigation.scrollTo({ top: 0, behavior: "smooth" });

      // Find the parent menu item for this submenu
      const parentItem = submenu.closest(".menu-item-has-children");
      const megaMenuItem = submenu.closest(".mega-menu-container");
      primaryMenu.style.left = `-${primaryMenu.clientWidth * depth}px`;
      if (megaMenuItem) megaMenuItem.style.display = "block";
      menu.style.display = "block";

      setTimeout(() => {
        parentItem.classList.add("submenu-visible");
      }, 100);
    }
  };

  const toggleSubMenu = (item) => {
    const subMenu = item.querySelector("ul.sub-menu");
    const siblings = item.parentNode.querySelectorAll("li.menu-item-has-children");

    if (siteNavigation.classList.contains("toggles")) {
      siblings.forEach((sibling) => {
        if (sibling !== item) {
          hideSubMenu(sibling, sibling.querySelector("ul.sub-menu"));
        }
      });
    }

    if (item.classList.contains("submenu-visible")) {
      hideSubMenu(item, subMenu);
    } else {
      showSubMenu(item, subMenu);
    }
  };

  // Panel Menus
  const buildPanelMenu = () => {
    subMenuToggle.forEach((item) => {
      const subMenu = item.querySelector("ul.sub-menu");

      // If menu is open, only tab within this menu
      item.addEventListener("keydown", (e) => {
        if (e.key === "Tab" && window.innerWidth < 1024) {
          const focusableElements = subMenu.querySelectorAll("a[href], button");
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          if (e.key !== "Tab" && e.keyCode !== 9) return;

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              lastFocusableElement.focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              firstFocusableElement.focus();
              e.preventDefault();
            }
          }
        }
      });

      // Disable tab on top level buttons
      const tabButton = item.querySelector("button");
      if (tabButton) tabButton.setAttribute("tabindex", "-1");
    });

    const backButton = siteNavigation.querySelectorAll(".back-button__button");

    backButton.forEach((item) => {
      item.addEventListener("click", () => {
        // Focus on the parent menu item
        const parentMenuItem = item.closest(".menu-item-has-children");
        parentMenuItem.querySelector("a").focus();
      });
    });
  };

  if (siteNavigation.classList.contains("menu-panel")) {
    buildPanelMenu();
  }

  // Set mobile menu height
  const setMenuHeight = () => {
    if (window.innerWidth <= 1024) {
      const headerHeight = header.offsetHeight;
      const viewportHeight = window.innerHeight;
      const menuHeight = viewportHeight - headerHeight;
      siteNavigation.style.setProperty("--menu-top", `${headerHeight}px`);
    } else {
      siteNavigation.style.setProperty("--menu-top", "");
    }
  };

  setMenuHeight();

  // Sub sub menu positioning for desktop hover
  if (window.innerWidth >= 1024) {
    subSubMenuHover.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        const subMenu = item.querySelector("ul.sub-menu");
        const rect = subMenu.getBoundingClientRect();
        const overflowRight = rect.right > window.innerWidth;
        const overflowLeft = rect.left < 0;

        if (overflowRight) {
          subMenu.style.left = "auto";
          subMenu.style.right = "100%";
        } else if (overflowLeft) {
          subMenu.style.left = "100%";
          subMenu.style.right = "auto";
        }
      });
    });
  }

  // Event listeners
  // =============================================================================

  window.addEventListener("resize", () => {
    window.innerWidth < 1024 ? removeDropdownOpened() : "";
    // Debounce setMenuHeight on resize
    let resizeTimeout;
    if (resizeTimeout) clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      setMenuHeight();
    }, 150);

    // If mobile menu is open then close mobile menu
    if (menuToggle.getAttribute("aria-expanded") === "true") {
      closeMobile();
    }
  });

  window.addEventListener("scroll", () => {
    removeDropdownOpened();
  });

  document.addEventListener("click", (event) => {
    if (!siteNavigation.contains(event.target)) removeDropdownOpened();
  });

  desktopClickControllers.forEach((item) => {
    item.addEventListener("click", () => {
      if (menuToggle.getAttribute("aria-expanded") === "true") return;
      item.classList.toggle("dropdown-opened");
      removeDropdownOpened(item);
    });
  });

  menuToggle.addEventListener("click", (e) => {
    e.stopPropagation();
    menuToggle.getAttribute("aria-expanded") === "true" ? closeMobile() : openMobile();
  });

  subMenuToggle.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.stopPropagation();
      // If target is A or mobile menu is false, do nothing
      if (e.target.tagName === "A" || menuToggle.getAttribute("aria-expanded") === "false") return;
      toggleSubMenu(item);
    });

    // Add keydown event to prevent link activation on Enter key
    item.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && menuToggle.getAttribute("aria-expanded") === "true") {
        e.preventDefault();
        e.stopPropagation();
        toggleSubMenu(item);
      }
    });
  });

  // Close menu if clicked outside of the menu
  document.addEventListener("click", (event) => {
    if (
      !siteNavigation.contains(event.target) &&
      !menuToggle.contains(event.target) &&
      menuToggle.getAttribute("aria-expanded") === "true" &&
      html.classList.contains("menu-opened")
    ) {
      closeMobile();
    }
  });
};

export { initNavigation };
